import defaultSettings from "@/settings";

const title = defaultSettings.title || "默认标题-来找我呀";

export default function getPageTitle(pageTitle) {
  // console.log(pageTitle);
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js